import React, {Component} from 'react';
import {Grid} from '@material-ui/core';
import {connect} from 'react-redux';
import {T} from 'Actions/translate';
import util from 'Utils/commonUtil';
import Header from 'Components/common/Header';
import {InfoOutlined} from '@material-ui/icons';
import copy from 'copy-to-clipboard';
import {customerConfirmLink} from 'Utils/urlUtil';

import {openNotification} from 'Actions/notification';

import {
    getQuote,
    getCustomerQuote,
    getCartCount,
    getMoreProducts,
    operationLog,
} from 'Actions/order';

class OrderSuccess extends Component {
    state = {
        timer: 5,
        pageLoad: true,
        displayTMProduct: false,
        isDemoSite: false,
        isQuoteInfor: false,
    };

    intervalTimer = null;

    componentWillMount() {
        const {localData} = this.props;
        if (localData.roleType && !localData.isProxyProcess) {
            if (!this.getBatchAddSkuShipTo()) {
                window.clearInterval(this.intervalTimer);
                this.intervalTimer = setInterval(() => {
                    if (this.state.timer === 0) {
                        this.goToOrderList();
                    } else {
                        this.setState({timer: this.state.timer - 1});
                    }
                }, 1000);
            }
        }
    }

    getBatchAddSkuEmail = () => {
        let currentBatchAddSkuEmail = '';
        if (
            this.props.location.state &&
            this.props.location.state.bacthAddSkuEmail
        ) {
            currentBatchAddSkuEmail =
                this.props.location.state.bacthAddSkuEmail;
        }
        return currentBatchAddSkuEmail;
    };

    getBatchAddSkuShipTo = () => {
        let currentBatchAddSkuShipTo = '';
        if (
            this.props.location.state &&
            this.props.location.state.batchAddSkuShipTo
        ) {
            currentBatchAddSkuShipTo =
                this.props.location.state.batchAddSkuShipTo;
        }
        return currentBatchAddSkuShipTo;
    };

    goToOrderList = () => {
        this.props.history.replace('/myOrderList/unreceived', {
            fromOrderSuccess: true,
        });
    };

    goToLtoOrderList = () => {
        this.props.history.replace('/purchase/ltoHistoryList', {
            fromOrderSuccess: true,
        });
    };

    isLtoOrder = () => {
        const {addProxyOrder} = this.props;
        let isLtoOrderFlag = false;
        if (addProxyOrder && addProxyOrder.length > 0) {
            addProxyOrder.map((item, index) => {
                if (item.orderType === 'LTO') {
                    isLtoOrderFlag = true;
                }
            });
        }
        return isLtoOrderFlag;
    };

    // Hide API Get Loading
    hideloading = () => {
        this.setState({
            pageLoad: false,
        });
    };

    goToShoppingCart = () => {
        if (
            this.props.location.state &&
            this.props.location.state.supplyCenterId
        ) {
            this.props.history.push('/purchase/shoppingCart', {
                customerEmail: util.getPurchaseCustomerEmail(),
                customerName: util.getPurchaseCustomerName(),
            });
        } else {
            this.props.history.push('/purchase/shoppingCart', {
                batchAddShipTo: this.getBatchAddSkuShipTo(),
                batchAddEmail: this.getBatchAddSkuEmail(),
                customerEmail: util.getPurchaseCustomerEmail(),
                customerName: util.getPurchaseCustomerName(),
            });
        }
    };

    getQuote = (param) => {
        this.props.getCustomerQuote(
            param,
            this.props.localData,
            this.quoteCallback,
        );
        this.props.operationLog({
            opTarget: 'view_sku_promo_order',
            opContent: param,
            opReqUrl: 'api/quote/sku',
        });
    };

    quoteCallback = (res) => {
        if (res.status === 'success' && res.data.length !== 0) {
            this.setState({
                isQuoteInfor: true,
            });
        } else if (res.status === 'success' && res.data.length === 0) {
            this.props.openNotification(
                T('notification_quote_null'),
                'success',
            );
        } else {
            this.props.openNotification(
                T('notification_get_quote_failed'),
                'success',
            );
        }
    };

    viewSkuDetailOrderOperation = (sku) => {
        this.props.operationLog({
            opTarget: 'view_sku_detail_order',
            opContent: sku,
        });
    };

    getPurchaseCustomerName = () => {
        let customerName = '';
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        if (JSON.stringify(routerState) !== '{}') {
            customerName = routerState.customerName;
        }
        return customerName;
    };

    getPurchaseCustomerEmail = () => {
        let customerEmail = undefined;
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        if (JSON.stringify(routerState) !== '{}') {
            customerEmail = routerState.customerEmail;
        }
        return customerEmail;
    };

    copyToClipBoard = (orderNumber) => {
        copy(`${customerConfirmLink}${orderNumber} `);
        this.props.openNotification(T('notification_copy_success'), 'success');
    };

    showCustomerCopyLinkMessage = () => {
        this.props.openNotification(
            T(
                'lto_purchase_order_copy_confirmation_link_to_customer_confirm_lto',
            ),
            'danger',
        );
    };

    render() {
        const {displayTMProduct} = this.state;
        const {localData, addProxyOrder, submitF1Order, cartCount} = this.props;

        let notificationInforBefor = T('notification_jump_to');
        let notificationInforAfter = T('notification_view_order_details');
        let orderSuccessHead = 'order-success-head';
        if (localData.roleType && !localData.isProxyProcess) {
            if (!this.getBatchAddSkuShipTo()) {
                notificationInforBefor = T('notification_jump_to');
                notificationInforAfter = T(
                    'notification_go_to_admin_view_f1_details',
                );
                orderSuccessHead =
                    'order-success-head container-max-width is-fixed';
            }
        }

        let foneOrderSuccessFlag = true;
        if (localData.roleType && localData.isProxyProcess) {
            foneOrderSuccessFlag = false;
        } else if (
            localData.roleType === 0 &&
            typeof localData.isProxyProcess === 'undefined'
        ) {
            foneOrderSuccessFlag = false;
        } else if (localData.roleType === 3 && !localData.isProxyProcess) {
            if (!this.getBatchAddSkuShipTo()) {
                foneOrderSuccessFlag = false;
            }
        }

        console.log('addProxyOrder=====================', addProxyOrder);

        return (
            <div className="order-success">
                <Grid
                    className={orderSuccessHead}
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid className="page-title" item xs={12}>
                        {!foneOrderSuccessFlag ? (
                            <Header
                                userIconEvent={this.goToUserCenter}
                                shoppingCartEvent={this.goToShoppingCart}
                                backEvent={this.backEvent}
                                increment={0}
                                hasShoppingCart={true}
                                hasUserCenter={true}
                                hasArrowBackIos={displayTMProduct}
                                cartCount={cartCount}
                                orderSubmitPage={true}
                                noHomeButton={true}></Header>
                        ) : (
                            <div>
                                <Header
                                    userIconEvent={this.goToUserCenter}
                                    shoppingCartEvent={this.goToShoppingCart}
                                    backEvent={this.backEvent}
                                    increment={0}
                                    hasShoppingCart={false}
                                    hasUserCenter={true}
                                    hasArrowBackIos={displayTMProduct}
                                    cartCount={cartCount}
                                    orderSubmitPage={true}
                                    noHomeButton={true}></Header>
                            </div>
                        )}
                    </Grid>
                </Grid>

                <Grid
                    className="order-content"
                    container
                    spacing={0}
                    testid="order-submit-success"
                    justify={'space-evenly'}>
                    <Grid className="success-title" item xs={12}>
                        <span testid="order-submit-success-text">
                            {T('order_sumbit_success')}
                        </span>
                    </Grid>
                    {localData.roleType &&
                    !localData.isProxyProcess &&
                    !this.getBatchAddSkuShipTo() ? (
                        <Grid className={'order-content-first'} item xs={12}>
                            {T('order_number_colon')}
                            {foneOrderSuccessFlag ? (
                                submitF1Order &&
                                submitF1Order.length > 0 &&
                                submitF1Order.map((f1order, i) => (
                                    <div key={i} testid="order-number">
                                        {f1order.number}
                                    </div>
                                ))
                            ) : (
                                <span testid="order-number">
                                    {submitF1Order.number}
                                </span>
                            )}
                        </Grid>
                    ) : (
                        addProxyOrder &&
                        addProxyOrder.map((item, index) => (
                            <Grid
                                key={index}
                                className="order-content-first"
                                item
                                xs={12}>
                                {item.orderType === 'LTO'
                                    ? T('lto_history_detail_preorder_number')
                                    : T('order_number_colon')}
                                <span
                                    testid={
                                        item.orderType === 'LTO'
                                            ? 'lto-order-number'
                                            : 'order-number'
                                    }>
                                    {item.number}
                                </span>
                            </Grid>
                        ))
                    )}

                    <Grid className="order-content-second" item xs={12}>
                        {notificationInforBefor}
                        {this.isLtoOrder() ? (
                            <span onClick={this.goToLtoOrderList}>
                                {T('lto_history_detail_my_preorder_number')}
                            </span>
                        ) : (
                            <span onClick={this.goToOrderList}>
                                {T('order_my_order')}
                            </span>
                        )}
                        {notificationInforAfter}
                    </Grid>

                    {addProxyOrder &&
                    addProxyOrder.length > 0 &&
                    addProxyOrder[0].orderType === 'LTO' ? (
                        <Grid className="copy-confirm-channel" item xs={12}>
                            <div className="copy-wrapper">
                                <div className="copy-confirm-channel-label">
                                    {T(
                                        'lto_purchase_order_customer_confirmation_link',
                                    )}
                                    <label className="customer_confirmation-icon">
                                        <InfoOutlined
                                            onClick={() =>
                                                this.showCustomerCopyLinkMessage()
                                            }
                                        />
                                    </label>
                                    ：
                                    <div
                                        className="copy-confirm-channel-link"
                                        onClick={() =>
                                            this.copyToClipBoard(
                                                addProxyOrder[0].number,
                                            )
                                        }>
                                        {T(
                                            'lto_purchase_order_copy_confirmation_link',
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    ) : null}
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {localData, order, replenishment, ltoPurchaseOrder} = state;

    return {
        localData: localData,
        addProxyOrder: ltoPurchaseOrder.addProxyOrder,
        submitF1Order: replenishment.submitF1Order,
        tmProductList: order.tmProductList,
        listLoaded: order.searchProductListLoaded,
        searchProductList: order.searchProductList,
        searchProductLoadingMore: order.searchProductLoadingMore,
        cartCount: order.cartCount,
        quoteInfor: order.quoteInfor.data,
        quoteCustomerInfor: order.quoteCustomerInfor.data,
    };
};

const mapDispatchToProps = {
    getQuote,
    getCustomerQuote,
    openNotification,
    getCartCount,
    getMoreProducts,
    operationLog,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderSuccess);
